import React, { useState } from "react";
import { Button } from "@mantine/core";
import { IconPrinter } from "@tabler/icons";
import { showNotification } from "@mantine/notifications";
import { useTranslation } from "react-i18next";
import { useServerApi } from "../hooks/userServerApi";
import { openFileUrl } from "../utils/openReport";

const OrderInvestmentTransactionActionList = ({ form }) => {
  const [api] = useServerApi();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const transactionId = form?.values?._id;

  const handlePrint = async () => {
    if (!transactionId) {
      showNotification({
        color: "red",
        title: t("Error"),
        message: "Please save the transaction before printing.",
      });
      return;
    }

    try {
      setLoading(true);
      const result = await api.OrderInvestmentTransaction.printArForm(
        transactionId,
        form.values.arForm
      );
      if (result?.url) {
        await openFileUrl(result.url);
        return;
      }
      throw new Error("No print URL returned");
    } catch (error) {
      showNotification({
        color: "red",
        title: t("Error"),
        message: error?.message || "Failed to print AR Form",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      size="xs"
      fullWidth
      leftIcon={<IconPrinter size={14} />}
      onClick={handlePrint}
      loading={loading}
    >
      {t("Print AR Form")}
    </Button>
  );
};

export default OrderInvestmentTransactionActionList;
